import client from "./client";

export const subscribePush = (subscription) => client.put("/push/subscribe", subscription).then((r) => r.data);

export const unsubscribePush = () => client.delete("/push/subscribe").then((r) => r.data);
